import moment from "moment";

export const getTimeConversion = (timestamp) => {
  const duration = moment.duration(timestamp, "seconds");

  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  let timeString = "";

  if (months > 0) {
    timeString = `${months} months`;
  } else if (days > 0) {
    timeString = `${days} days`;
  } else if (hours > 0) {
    timeString = `${hours} hours`;
  } else if (minutes > 0) {
    timeString = `${minutes} minutes`;
  } else if (seconds > 0) {
    timeString = `${seconds} seconds`;
  }

  return timeString;
};
